
import {
  default as request
} from '@/untils/api'
// 登录
export const userLogin = async(options) => {
  return await request({
    url: '/user/login',
    method: 'POST',
    data: options
  });
}
export const loginOut = async(options) => {
  return await request({
    url: '/logout',
    method: 'POST',
    data: options
  });
}
export const getUserInfo = async(options) => {
  return await request({
    url: '/getInfo',
    method: 'get',
    params: options
  });
}
// 获取需求列表
export const JobRequirementList = async(options) => {
  return await request({
    url: '/flowable/task/my-stars-list',
    method: 'get',
    params: options
  });
}

// 保存需求
export const saveJobRequirement = async(options) => {
  return await request({
    url: '/job/saveRequirement',
    method: 'post',
    data: options
  });
}
// 保存需求
export const saveDraft = async(options) => {
  return await request({
    url: '/stars/saveDraft',
    method: 'post',
    data: options
  });
}
// 获取PositionType下拉框值
export const getPositionType = async(options) => {
  return await request({
    url: '/stars/getPositionType',
    method: 'post',
    data: options
  });
}
// 获取下拉框
export const getSelectList = async(options) => {
  return await request({
    url: '/stars/get-const-list',
    method: 'post',
    data: options
  });
}
// 获取下拉框
export const getKVSelectList = async(options) => {
  return await request({
    url: '/stars/get-kv-data',
    method: 'post',
    data: options
  });
}
// 删除表格数据
export const deleteTableItem = async(options) => {
  return await request({
    url: '/flowable/task/delete',
    method: 'DELETE',
    data: options
  });
}
// 获取任务列表
export const getMyStarsCount = async(options) => {
  return await request({
    url: '/flowable/task/my-stars-count',
    method: 'get',
    params:options
  });
}
// 导出表格
export const exportExcel = async(options) => {
  return await request({
    url: '/flowable/task/export',
    method: 'post',
    data:options
  });
}
// 删除draft状态需求
export const deleteRequirement = async(id) => {
  return await request({
    url:`/stars/deleteDraft/${id}`,
    method: 'post'
  });
}
// 获取replacewho
export const getReplaceWho = async(options) => {
  return await request({
    url:'/stars/user-list-search',
    // url:'/stars/user-list',
    method: 'post',
    data:options
  });
}
// 获取area列表
export const getAreaList = async(id) => {
  return await request({
    url:`/stars/getArea/${id}`,
    method: 'post',
  });
}// 获取city列表 接口替换为/stars/getCityByAreaAndRegion 0511
export const getCityList = async(options) => {
  return await request({
    url:`/stars/getCityByAreaAndRegion`,
    method: 'post',
    data:options
  });
}
// export const getCityList = async(id) => {
//   return await request({
//     url:`/stars/getCity/${id}`,
//     method: 'post',
//   });
// }
export const getReginList = async(options) => {
  return await request({
    url:`/stars/getRegion`,
    method: 'post',
  });
}
export const getRegionSearch = async(options) => {
  return await request({
    url:`/stars/getRegionSearch `,
    method: 'post',
  });
}
// 是否显示Salary Budget
export const showSalaryBudget = async(options) => {
  return await request({
    url:`/stars/show-salary-budget `,
    method: 'post',
    data:options
  });
}
// 获取Market Benchmark
export const marketBenchmark = async(options) => {
  return await request({
    url:`/stars/market/benchmark?cityId=${options.cityId}&deptId=${options.deptId}&designation=${options.designation}`,
    method: 'post'
  });
}
//获取标头信息
export const getTitleInfo = async(options) => {
  return await request({
    url:`/stars/td-title/info`,
    method: 'post',
    data:options
  });
}
// 保存表头
export const saveTitleInfo = async(options) => {
  return await request({
    url:`/stars/td-title/add-save`,
    method: 'post',
    data:options
  });
}
// 获取公司列表
export const getCompany = async(options) => {
  return await request({
    url:`/stars/stars-company/list`,
    method: 'get',
    params:options
  });
}
//批量审批
export const batchComplete = async(options) => {
  return await request({
    url:`/flowable/task/batchComplete`,
    method: 'post',
    data:options
  });
}
//批量审批
export const batchSetAssigneeComplete = async(options) => {
  return await request({
    url:`/flowable/task/batchSetAssigneeComplete`,
    method: 'post',
    data:options
  });
}
//判断jrcode
export const getJrCode = async(options) => {
  return await request({
    url:`/stars/getJrCode`,
    method: 'post',
    data:options
  });
}
// 获取getSectorParam // 0430
export const getSectorParam = async(options) => {
  return await request({
    url:`/stars/preOnboarding/getSectorParam`,
    method: 'get',
    params:options
  });
}